export default __webpack_public_path__ + "static/media/ladak2.f73edb5d.jpg";